import { Flex } from '@chakra-ui/react'

import { useCustomFormBuilder } from './contexts/CustomFormBuilderManagerContext/Provider'
import CustomFormBuilderQuestion from './components/CustomFormBuilderQuestion'
import UpdatCustomFormBuilder from './components/UpdateCustomFormBuilder'
import CustomFormBuilderIsProtected from './components/CustomFormBuilderIsProtected'
import DeleteCustomFormCard from './components/DeleteCustomFormCard'

export default function CustomFormBuilderComponent() {
  const { canDeleteForm, canUpdateForm } = useCustomFormBuilder()

  return (
    <Flex borderRight="1px solid" borderColor="borderColor" p={4} flexDir="column" gap={4}>
      {canUpdateForm && <UpdatCustomFormBuilder />}
      <CustomFormBuilderIsProtected />
      <CustomFormBuilderQuestion />
      {canDeleteForm && <DeleteCustomFormCard />}
    </Flex>
  )
}
